module.exports = __webpack_public_path__ + "img/properlly-guy-left.79c6736.png";